import { render, staticRenderFns } from "./product-query.vue?vue&type=template&id=350f06a8&"
import script from "./product-query.vue?vue&type=script&lang=ts&"
export * from "./product-query.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports